import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchSv = () => {
    return <AdvancedSearch languageCode="sv" />
}

export default AdvancedSearchSv
